import React, { useState } from 'react';
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';

import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import axios from "axios";
import AxiosInstance from 'src/components/Axios';
import CIcon from '@coreui/icons-react';
import { cilPen, cilPlus, cilTrash, cilClone, cilPrint } from '@coreui/icons';
import { confirmAlert } from 'react-confirm-alert';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';


const page = 1;
const postPerPage = 0;
const pageSize = 20;

const urlApi = '/galleries';

export async function LoaderGallery({ params }) {
  let res = await AxiosInstance.get('/galleries?page=' + page).then((response) => {
    return response;
  });
  return res;
}





const Gallery = ({ user_data }) => {
  if (!Permissions(user_data, 'Gallery', 'VIEW_GALLERY')) {
    return <PermissionsNoPage />;
  }
  const { data } = useLoaderData();
  const [rows, setRows] = useState(data['hydra:member']);
  const postPerPage = page * data['hydra:totalItems'];

  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);

  const getRowsTable = () => {
    AxiosInstance.get('/galleries?page=' + page).then((response) => {
      if (response.status == 200)
        setRows(response.data['hydra:member']);
    });
  }
  const popup = MyToastify();

  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  function Deleted(row) {
    // console.log('row', row);
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      // message: 'Are you sure to do this.',
      message: (
        <>

        </>
      ),
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = AxiosInstance.delete(urlApi + '/' + row.id).then((response) => {
              getRowsTable();
              // Вивести popup про успішне видалення замовлення
              popup.toastifySuccess('Видалено');
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };


  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      disableColumnMenu: true,
      width: 70
    },
    {
      field: 'name',
      headerName: 'Назва',
      width: 400,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      field: 'type',
      headerName: 'Тип',
      sortable: false,
      disableColumnMenu: true,
      width: 150
    },
    {
      field: 'year',
      headerName: 'Рік',
      sortable: false,
      disableColumnMenu: true,
      width: 150
    },
    {
      field: "action",
      // headerName: "Action",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      // renderCell: (params) => {
      //   return <Link to={'/gallery/update/' + params.row.id}>Редагувати</Link>;
      // }
      renderCell: (params) => {
        return <Link to={'/gallery/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
    {
      field: "delete",
      // headerName: "Видалити",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" title="Видалити замовлення"
      //     onClick={() => {
      //       Deleted(params.row)
      //     }
      //     }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }

    },
  ];



  return (
    <CRow>
      <ToastContainer />

      <CCol xs={12}>
        <CCard className="mb-4 mt-4">
          <CCardHeader className='items_card_header'>
            {/* <strong> */}
            Галерея
            {/* </strong> */}
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_solo'>
              <p className="text-medium-emphasis small">
                <Link to="/gallery/create" className='link_add_button'>
                  {/* Створити */}
                  <CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                    {/* Створити */}
                    Add
                  </CButton>
                </Link>
              </p>
            </div>
            <div style={{ height: 600, width: '100%' }}>

              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                rowsPerPageOptions={[postPerPage]}
                // checkboxSelection

                components={{ Pagination: CustomPagination }}
                headerHeight={44}
                getRowClassName={(params) =>
                  selectedIds.includes(params.row.id) ? 'active-row' : ''
                }
                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}


              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Gallery;
